module.exports = __webpack_public_path__ + "img/outdoor.6a8d2d1e.jpg";